// This file is automatically generated from ingestAssets.mjs
import { ImageTokens } from '../../../components/Image/Image.types';
const imageTokens: ImageTokens = {
	'sds-assets/base/image/square/aggressiveMixAOR': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/aggressiveMixAOR.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/alibabaBABA': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/alibabaBABA.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/allThatGlittersGLTR': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/allThatGlittersGLTR.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/alphabetGOOG': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/alphabetGOOG.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/amazonAMZN': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/amazonAMZN.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/amdAMD': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/amdAMD.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/americanInnovatorsVGT': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/americanInnovatorsVGT.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/amexAXP': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/amexAXP.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/appleAAPL': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/appleAAPL.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/avalancheAVAX': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/avalancheAVAX.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/bankOfAmericaBAC': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/bankOfAmericaBAC.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/bigMoneyVFH': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/bigMoneyVFH.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/bitcoinBTC': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/bitcoinBTC.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/bitcoinCashBCH': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/bitcoinCashBCH.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/blueChipsMGC': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/blueChipsMGC.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/bpBP': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/bpBP.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/cardanoADA': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/cardanoADA.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/chainlinkLINK': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/chainlinkLINK.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/chaseJPM': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/chaseJPM.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/chipotleCMG': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/chipotleCMG.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/cleanAndGreenICLN': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/cleanAndGreenICLN.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/cocaColaKO': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/cocaColaKO.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/colossalChinaGXC': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/colossalChinaGXC.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/conservativeMixAOK': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/conservativeMixAOK.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/copyTheExpertsGURU': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/copyTheExpertsGURU.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/cosmosATOM': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/cosmosATOM.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/costcoCOST': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/costcoCOST.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/cvsCVS': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/cvsCVS.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/dataDefendersCIBR': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/dataDefendersCIBR.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/defendingAmericaITA': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/defendingAmericaITA.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/deliciousDividendsSCHD': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/deliciousDividendsSCHD.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/disneyDIS': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/disneyDIS.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/doTheRightThingSUSA': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/doTheRightThingSUSA.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/essentialEuropeVGK': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/essentialEuropeVGK.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/ethereumClassicETC': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/ethereumClassicETC.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/ethereumETH': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/ethereumETH.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/etsyETSY': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/etsyETSY.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/facebookFB': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/facebookFB.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/greyscaleBitcoinTrustGBTC': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/greyscaleBitcoinTrustGBTC.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/greyscaleEthereumTrustETHE': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/greyscaleEthereumTrustETHE.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/homeDepotHD': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/homeDepotHD.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/homeSweetHomeXHB': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/homeSweetHomeXHB.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/internetTitansFDN': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/internetTitansFDN.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/jpMorganChaseJPM': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/jpMorganChaseJPM.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/krogerKR': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/krogerKR.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/litecoinLTC': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/litecoinLTC.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/liveLongAndProsper': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/liveLongAndProsper.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/lululemonLULU': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/lululemonLULU.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/lyftLYFT': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/lyftLYFT.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/masterCardMA': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/masterCardMA.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/mcDonaldsMCD': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/mcDonaldsMCD.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/microsoftMSFT': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/microsoftMSFT.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/moderateMixAOM': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/moderateMixAOM.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/netflixNFLX': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/netflixNFLX.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/nikeNKE': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/nikeNKE.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/nvidiaNVDA': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/nvidiaNVDA.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/onCloudNineSKYY': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/onCloudNineSKYY.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/pacificPowerhousesVPL': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/pacificPowerhousesVPL.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/parkMyCashMINT': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/parkMyCashMINT.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/pfizerPFE': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/pfizerPFE.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/publicWorksMUB': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/publicWorksMUB.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/rawEarthGNR': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/rawEarthGNR.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/retailTherapyXRT': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/retailTherapyXRT.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/robotsRisingROBO': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/robotsRisingROBO.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/shellSHEL': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/shellSHEL.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/slowAndSteadySPLV': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/slowAndSteadySPLV.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/smallButMightyVB': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/smallButMightyVB.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/socialMediaManiaSOCL': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/socialMediaManiaSOCL.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/solanaSOL': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/solanaSOL.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/spotifySPOT': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/spotifySPOT.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/starbucksSBUX': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/starbucksSBUX.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/targetTGT': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/targetTGT.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/teslaTSLA': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/teslaTSLA.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/toyotaTM': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/toyotaTM.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/uberUBER': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/uberUBER.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/uncleSamVGIT': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/uncleSamVGIT.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/underArmourUAA': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/underArmourUAA.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/uniswapUNI': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/uniswapUNI.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/upAndComingVWO': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/upAndComingVWO.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/visaV': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/visaV.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/walmartWMT': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/walmartWMT.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/waterTheWorldPHO': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/waterTheWorldPHO.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/wellsFargoWFC': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/wellsFargoWFC.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/wendysWEN': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/wendysWEN.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/youngMoneyMILN': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/youngMoneyMILN.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/yumYUM': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/yumYUM.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/zoomZM': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/zoomZM.png',
		ratio: 'square',
	},
	'sds-assets/base/image/square/emergencyFund': {
		url: 'https://assets.stash.com/sds-assets/base/image/square/emergencyFund.png',
		ratio: 'square',
	},
	'sds-assets/base/image/wide/trackYourSpend': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/trackYourSpend.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/earnStockBack': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/earnStockBack.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/stockRoundUp': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/stockRoundUp.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/cardSecurity': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/cardSecurity.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/altCoins': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/altCoins.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/bitcoinUniverse': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/bitcoinUniverse.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/strongAndStableStocks': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/strongAndStableStocks.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/broadMarket': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/broadMarket.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/commodities': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/commodities.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/consumerStaples': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/consumerStaples.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/diversifiedMixes': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/diversifiedMixes.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/energy': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/energy.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/ethereumUniverse': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/ethereumUniverse.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/finance': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/finance.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/growthStocks': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/growthStocks.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/goodsAndServices': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/goodsAndServices.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/healthcare': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/healthcare.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/industrials': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/industrials.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/materials': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/materials.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/media': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/media.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/missionAndCauses': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/missionAndCauses.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/realEstate': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/realEstate.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/tech': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/tech.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/technologyAndInnovation': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/technologyAndInnovation.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/thematic': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/thematic.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/utilities': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/utilities.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/buildingBlocks': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/buildingBlocks.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/usTreasuryIncome': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/usTreasuryIncome.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/specialtyIndustries': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/specialtyIndustries.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/trendingEtfs': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/trendingEtfs.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/trendingStocks': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/trendingStocks.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/largeGlobalCompanies': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/largeGlobalCompanies.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/largeUSCompanies': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/largeUSCompanies.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/wide/topStockBack': {
		url: 'https://assets.stash.com/sds-assets/base/image/wide/topStockBack.png',
		ratio: 'wide',
	},
	'sds-assets/base/image/shortWide/altCoins': {
		url: 'https://assets.stash.com/sds-assets/base/image/shortWide/altCoins.png',
		ratio: 'shortWide',
	},
	'sds-assets/base/image/shortWide/bitcoinUniverse': {
		url: 'https://assets.stash.com/sds-assets/base/image/shortWide/bitcoinUniverse.png',
		ratio: 'shortWide',
	},
	'sds-assets/base/image/shortWide/strongAndStableStocks': {
		url: 'https://assets.stash.com/sds-assets/base/image/shortWide/strongAndStableStocks.png',
		ratio: 'shortWide',
	},
	'sds-assets/base/image/shortWide/broadMarket': {
		url: 'https://assets.stash.com/sds-assets/base/image/shortWide/broadMarket.png',
		ratio: 'shortWide',
	},
	'sds-assets/base/image/shortWide/commodities': {
		url: 'https://assets.stash.com/sds-assets/base/image/shortWide/commodities.png',
		ratio: 'shortWide',
	},
	'sds-assets/base/image/shortWide/consumerStaples': {
		url: 'https://assets.stash.com/sds-assets/base/image/shortWide/consumerStaples.png',
		ratio: 'shortWide',
	},
	'sds-assets/base/image/shortWide/diversifiedMixes': {
		url: 'https://assets.stash.com/sds-assets/base/image/shortWide/diversifiedMixes.png',
		ratio: 'shortWide',
	},
	'sds-assets/base/image/shortWide/energy': {
		url: 'https://assets.stash.com/sds-assets/base/image/shortWide/energy.png',
		ratio: 'shortWide',
	},
	'sds-assets/base/image/shortWide/ethereumUniverse': {
		url: 'https://assets.stash.com/sds-assets/base/image/shortWide/ethereumUniverse.png',
		ratio: 'shortWide',
	},
	'sds-assets/base/image/shortWide/finance': {
		url: 'https://assets.stash.com/sds-assets/base/image/shortWide/finance.png',
		ratio: 'shortWide',
	},
	'sds-assets/base/image/shortWide/growthStocks': {
		url: 'https://assets.stash.com/sds-assets/base/image/shortWide/growthStocks.png',
		ratio: 'shortWide',
	},
	'sds-assets/base/image/shortWide/goodsAndServices': {
		url: 'https://assets.stash.com/sds-assets/base/image/shortWide/goodsAndServices.png',
		ratio: 'shortWide',
	},
	'sds-assets/base/image/shortWide/healthcare': {
		url: 'https://assets.stash.com/sds-assets/base/image/shortWide/healthcare.png',
		ratio: 'shortWide',
	},
	'sds-assets/base/image/shortWide/industrials': {
		url: 'https://assets.stash.com/sds-assets/base/image/shortWide/industrials.png',
		ratio: 'shortWide',
	},
	'sds-assets/base/image/shortWide/materials': {
		url: 'https://assets.stash.com/sds-assets/base/image/shortWide/materials.png',
		ratio: 'shortWide',
	},
	'sds-assets/base/image/shortWide/media': {
		url: 'https://assets.stash.com/sds-assets/base/image/shortWide/media.png',
		ratio: 'shortWide',
	},
	'sds-assets/base/image/shortWide/missionAndCauses': {
		url: 'https://assets.stash.com/sds-assets/base/image/shortWide/missionAndCauses.png',
		ratio: 'shortWide',
	},
	'sds-assets/base/image/shortWide/realEstate': {
		url: 'https://assets.stash.com/sds-assets/base/image/shortWide/realEstate.png',
		ratio: 'shortWide',
	},
	'sds-assets/base/image/shortWide/tech': {
		url: 'https://assets.stash.com/sds-assets/base/image/shortWide/tech.png',
		ratio: 'shortWide',
	},
	'sds-assets/base/image/shortWide/technologyAndInnovation': {
		url: 'https://assets.stash.com/sds-assets/base/image/shortWide/technologyAndInnovation.png',
		ratio: 'shortWide',
	},
	'sds-assets/base/image/shortWide/thematic': {
		url: 'https://assets.stash.com/sds-assets/base/image/shortWide/thematic.png',
		ratio: 'shortWide',
	},
	'sds-assets/base/image/shortWide/utilities': {
		url: 'https://assets.stash.com/sds-assets/base/image/shortWide/utilities.png',
		ratio: 'shortWide',
	},
	'sds-assets/base/image/extraWide/altCoins': {
		url: 'https://assets.stash.com/sds-assets/base/image/extraWide/altCoins.png',
		ratio: 'extraWide',
	},
	'sds-assets/base/image/extraWide/bitcoinUniverse': {
		url: 'https://assets.stash.com/sds-assets/base/image/extraWide/bitcoinUniverse.png',
		ratio: 'extraWide',
	},
	'sds-assets/base/image/extraWide/strongAndStableStocks': {
		url: 'https://assets.stash.com/sds-assets/base/image/extraWide/strongAndStableStocks.png',
		ratio: 'extraWide',
	},
	'sds-assets/base/image/extraWide/broadMarket': {
		url: 'https://assets.stash.com/sds-assets/base/image/extraWide/broadMarket.png',
		ratio: 'extraWide',
	},
	'sds-assets/base/image/extraWide/commodities': {
		url: 'https://assets.stash.com/sds-assets/base/image/extraWide/commodities.png',
		ratio: 'extraWide',
	},
	'sds-assets/base/image/extraWide/consumerStaples': {
		url: 'https://assets.stash.com/sds-assets/base/image/extraWide/consumerStaples.png',
		ratio: 'extraWide',
	},
	'sds-assets/base/image/extraWide/diversifiedMixes': {
		url: 'https://assets.stash.com/sds-assets/base/image/extraWide/diversifiedMixes.png',
		ratio: 'extraWide',
	},
	'sds-assets/base/image/extraWide/energy': {
		url: 'https://assets.stash.com/sds-assets/base/image/extraWide/energy.png',
		ratio: 'extraWide',
	},
	'sds-assets/base/image/extraWide/ethereumUniverse': {
		url: 'https://assets.stash.com/sds-assets/base/image/extraWide/ethereumUniverse.png',
		ratio: 'extraWide',
	},
	'sds-assets/base/image/extraWide/finance': {
		url: 'https://assets.stash.com/sds-assets/base/image/extraWide/finance.png',
		ratio: 'extraWide',
	},
	'sds-assets/base/image/extraWide/growthStocks': {
		url: 'https://assets.stash.com/sds-assets/base/image/extraWide/growthStocks.png',
		ratio: 'extraWide',
	},
	'sds-assets/base/image/extraWide/goodsAndServices': {
		url: 'https://assets.stash.com/sds-assets/base/image/extraWide/goodsAndServices.png',
		ratio: 'extraWide',
	},
	'sds-assets/base/image/extraWide/healthcare': {
		url: 'https://assets.stash.com/sds-assets/base/image/extraWide/healthcare.png',
		ratio: 'extraWide',
	},
	'sds-assets/base/image/extraWide/industrials': {
		url: 'https://assets.stash.com/sds-assets/base/image/extraWide/industrials.png',
		ratio: 'extraWide',
	},
	'sds-assets/base/image/extraWide/materials': {
		url: 'https://assets.stash.com/sds-assets/base/image/extraWide/materials.png',
		ratio: 'extraWide',
	},
	'sds-assets/base/image/extraWide/media': {
		url: 'https://assets.stash.com/sds-assets/base/image/extraWide/media.png',
		ratio: 'extraWide',
	},
	'sds-assets/base/image/extraWide/missionAndCauses': {
		url: 'https://assets.stash.com/sds-assets/base/image/extraWide/missionAndCauses.png',
		ratio: 'extraWide',
	},
	'sds-assets/base/image/extraWide/realEstate': {
		url: 'https://assets.stash.com/sds-assets/base/image/extraWide/realEstate.png',
		ratio: 'extraWide',
	},
	'sds-assets/base/image/extraWide/tech': {
		url: 'https://assets.stash.com/sds-assets/base/image/extraWide/tech.png',
		ratio: 'extraWide',
	},
	'sds-assets/base/image/extraWide/technologyAndInnovation': {
		url: 'https://assets.stash.com/sds-assets/base/image/extraWide/technologyAndInnovation.png',
		ratio: 'extraWide',
	},
	'sds-assets/base/image/extraWide/thematic': {
		url: 'https://assets.stash.com/sds-assets/base/image/extraWide/thematic.png',
		ratio: 'extraWide',
	},
	'sds-assets/base/image/extraWide/utilities': {
		url: 'https://assets.stash.com/sds-assets/base/image/extraWide/utilities.png',
		ratio: 'extraWide',
	},
	'sds-assets/base/image/tall/earnStockCards': {
		url: 'https://assets.stash.com/sds-assets/base/image/tall/earnStockCards.png',
		ratio: 'tall',
	},
	'sds-assets/base/image/bleed/altCoins': {
		url: 'https://assets.stash.com/sds-assets/base/image/bleed/altCoins.png',
		ratio: 'bleed',
	},
	'sds-assets/base/image/bleed/waves': {
		url: 'https://assets.stash.com/sds-assets/base/image/bleed/waves.png',
		ratio: 'bleed',
	},
	'sds-assets/base/image/bleed/wavesLarge': {
		url: 'https://assets.stash.com/sds-assets/base/image/bleed/wavesLarge.png',
		ratio: 'bleed',
	},
	'sds-assets/base/image/bleed/wavesLargeDesktop': {
		url: 'https://assets.stash.com/sds-assets/base/image/bleed/wavesLargeDesktop.png',
		ratio: 'bleed',
	},
	'sds-assets/base/image/bleed/unfundedSmart': {
		url: 'https://assets.stash.com/sds-assets/base/image/bleed/unfundedSmart.svg',
		ratio: 'bleed',
	},
	'sds-assets/base/image/bleed/unfundedPersonal': {
		url: 'https://assets.stash.com/sds-assets/base/image/bleed/unfundedPersonal.svg',
		ratio: 'bleed',
	},
	'sds-assets/base/image/bleed/unfundedSmartDesktop': {
		url: 'https://assets.stash.com/sds-assets/base/image/bleed/unfundedSmartDesktop.svg',
		ratio: 'bleed',
	},
	'sds-assets/base/image/bleed/unfundedPersonalDesktop': {
		url: 'https://assets.stash.com/sds-assets/base/image/bleed/unfundedPersonalDesktop.svg',
		ratio: 'bleed',
	},
};
export default imageTokens;
export type ImageToken = keyof typeof imageTokens;
